export const buildArr = [
  {
    title: '拧紧“过紧日子”的制度螺栓',
    desc: '近日，中共中央、国务院印发了修订后的《党政机关厉行节约反对浪费条例》（以下简称《条例》）。这是时隔近12年之后，党中央对这一重要条例进行修订，与时俱进完善多项规定，进一步拧紧党政机关带头过紧日子的制度螺栓。特别是在“总则”中，《条例》新增“应当深入贯彻中央八项规定精神”最新表述，以制度机制固...',
    time: '2025-05-28'
  },
  {
    title: '中办印发《通知》在全党开展深入贯彻中央八项规定精神学习教育',
    desc: '近日，中共中央办公厅印发《关于在全党开展深入贯彻中央八项规定精神学习教育的通知》（以下简称《通知》）。《通知》指出，为贯彻落实党的二十届三中全会部署，巩固拓展学习贯彻习近平新时代中国特色社会主义思想主题教育成果，巩固深化党纪学习教育成果，锲而不舍落实中央八项规定精神，推进作风建设常态化长...',
    time: '2025-03-17'
  },
  {
    title: '中央八项规定精神学习专题',
    desc: '党的二十届三中全会审议通过的《中共中央关于进一步全面深化改革、推进中国式现代化的决定》明确提出“锲而不舍落实中央八项规定精神，健全防治形式主义、官僚主义制度机制”。为进一步深入学习习近平总书记关于中央八项规定的重要讲话精神，引导广大党员干部强化纪律规矩意识，本期推出《中央八项规定精神》专题学习...',
    time: '2025-03-13'
  },
  {
    title: '总书记在三中全会上的重要讲话发表，一起学习领悟！',
    desc: '《求是》杂志16日发表习近平总书记的重要文章《在党的二十届三中全会第二次全体会议上的讲话》。习近平总书记在这次重要讲话中，对如何贯彻落实三中全会精神提出“要深入学习领会全会精神”“要切实抓好《决定》部署的贯彻落实”“要扎实做好下半年工作”等明确要求。我们以摘要的形式，梳理其中要点，和大家一起学习领悟...',
    time: '2024-10-09'
  },
  {
    title: '又踏层峰辟新天——《中共中央关于进一步全面深化改革、推进中国式现代化的决定》诞生记',
    desc: '  向着全面建成社会主义现代化强国、实现第二个百年奋斗目标奋力前行，党和国家迎来又一个历史性时刻——    2024年7月18日下午，如潮掌声中，党的二十届三中全会正式通过《中共中央关于进一步全面深化改革、推进中国式现代化的决定》。站在继往开来的历史关口，又一次具有里程碑意义的重要会议胜利召开，新时代新征程进一步全面深化改革的冲锋号角响彻神州大地。以习近平同志为核心的党中央团结带领全党全军全国各族人民矢志不渝、勇毅前行，以进一步全面深化改革开辟中国式现代化广阔前景，将强国建设、民族复兴伟业不断推向前进。',
    time: '2024-10-09'
  },
  {
    title: '深刻把握“第二个结合”的精髓要义',
    desc: '新华社北京6月4日电 题：深刻把握“第二个结合”的精髓要义——二论学习贯彻习近平总书记在文化传承发展座谈会上的重要讲话精神!新华社评论员: “‘第二个结合’，是我们党对马克思主义中国化时代化历史经验的深刻总结，是对中华文明发展规律的深刻把握”。在文化传承发展座谈会上的重要讲话中，习近平总书记深刻揭示“两个结合”的重大意义，深入阐明“第二个结合”的精髓要义，进一步拓展和深化了我们党对推进马克思主义中国化时代化的规律性认识，为在新的历史起点上不断推进党的理论创新提供了科学指引...',
    time: '2023-06-04'
  },
  {
    title: '二十大精神关键词解读 |“两个确立” :理论、历史和实践逻辑的有机统一',
    desc: '党的二十大报告指出，十八大以来，我们党勇于进行理论探索和创新，以全新的视野深化对共产党执政规律、社会主义建设规律、人类社会发展规律的认识，取得重大理论创新成果，集中体现为新时代中国特色社会主义思想。确立习近平同志党中央的核心、全党的核心地位，确立习近平新时代中国特色社会主义思想的指导地位，体现了马克思主义理论逻辑、党的百年奋斗历史逻辑同新时代党和...',
    time: '2022-11-13'
  },
  {
    title: '以中国式现代化全面推进中华民族伟大复兴--深刻领会中国式现代化...',
    desc: '新蓝图鼓舞人心，谋新篇踔厉前行。长三角- -体化示范区出台方案，探索跨区域生态产品价值实现机制;海南洋浦港开展封关项目建设，奋力提升港口现代化水平;南方五省区农村电网巩固提升工程全面展开,为超6000万户农村居民提供高质量的供电服务······各地区各部门各有关方面正以昂扬的精神状态、务实的工作作风贯彻落实党的二十大...',
    time: '2022-11-11'
  },
  {
    title: '全面理解把握党的二十大报告阐明的新时代重大理论和实践问题',
    desc: '10月28日，学习时报头版刊发中央政法委秘书长陈一新关于 全面理解把握党的二十大报告的署名文章，从报告阐明的最具震撼性的问题、最具引领性的问题、最具方向性的问题、最具战略性的问题、最具主旨性的问题、最具全球性的问题、最具根本性的问题、最具警示性的问题等八个方面进行了系统阐述。文...',
    time: '2022-10-31'
  },
  {
    title: '深刻领会党的二十大的主题! - -论深入学习贯彻党的二十大精神',
    desc: '“高举中国特色社会主义伟大旗帜，全面贯彻新时代中国特色社会主义思想，弘扬伟大建党精神，自信自强、守正创新，踔厉奋发、勇毅前行，为全面建设社会主义现代化国家、全面推进中华民族伟大复兴而团结奋斗。”党的二十大的主题是大会的灵魂，是党和国家事业发展的总纲，也是我们学习宣传贯彻党的二十大精神必须深刻领会的重要内容。',
    time: '2022-10-28'
  },
  {
    title: '党的二十大主题的深邃意蕴',
    desc: '党的二十大的主题是:高举中国特色社会主义伟大旗帜，全面贯彻新时代中国特色社会主义思想，弘扬伟大建党精神，自信自强、守正创新，踔厉奋发、勇毅前行，为全面建设社会主义现代化国家、全面推进中华民族伟大复兴而团结奋斗。这- -鲜明主题是对党在新征程上举什么旗、走什么路、以什么样的精神状态、朝着什么样的目标继续前进的郑重宣示。',
    time: '2022-10-22'
  },
  {
    title: '习近平:高举中国特色社会主义伟大旗帜为全面建设社会主义现代化国家而团结奋斗',
    desc: '中国共产党第二十次全国代表大会,是在全党全国各族人民迈上全面建设社会主义现代化国家新征程、向第二个百年奋斗目标进军的关键时刻召开的一次十分重要的大会。',
    time: '2022-10-16'
  },
  {
    title: '中国共产党章程',
    desc: '中国共产党是中国工人阶级的先锋队，同时是中国人民和中华民族的先锋队，是中国特色社会主义事业的领导核心，代表中国先进生产力的发展要求，代表中国先进文化的前进方向，代表中国最广大人民的根本利益。党的最高理想和最终目标是实现共产主义。',
    time: '2022-10-03'
  }
]
